import { render, staticRenderFns } from "./RegisterGerente.vue?vue&type=template&id=0abd0620&"
import script from "./RegisterGerente.vue?vue&type=script&lang=js&"
export * from "./RegisterGerente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports